import type { LOAN_REQUEST_OFFER_SOURCE } from 'cpool-constants';
import { OFFER_DOCUMENT_UPLOAD_STATUSES } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    id: string;
    source: LOAN_REQUEST_OFFER_SOURCE;
    documents: string[];
};
export const schemaLoanRequestResolver_GetOfferDocumentsUploadData = z
    .object({
        uploadStatus: z.nativeEnum(OFFER_DOCUMENT_UPLOAD_STATUSES),
        url: z.string(),
    })
    .nullable();

export type SchemaLoanRequestResolver_GetOfferDocumentsUploadData = z.infer<
    typeof schemaLoanRequestResolver_GetOfferDocumentsUploadData
>;

export type LoanRequestResolver_GetOfferDocumentsUploadData = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetOfferDocumentsUploadData
>;
